import { ICtgLoyaltyTransaction } from 'types/ctg-loyalty';

import { routes } from './routing';

/** Net rewards points from provisional guest earn transactions (earned + bonus − used − deducted). */
export const tallyProvisionalGuestPointsBalance = (
  transactions: Pick<
    ICtgLoyaltyTransaction,
    'bonusPointsEarned' | 'pointsDeducted' | 'pointsEarned' | 'pointsUsed'
  >[],
): number =>
  transactions.reduce(
    (sum, transaction) =>
      sum +
      (transaction.pointsEarned ?? 0) +
      (transaction.bonusPointsEarned ?? 0) -
      (transaction.pointsUsed ?? 0) -
      (transaction.pointsDeducted ?? 0),
    0,
  );

export const GUEST_IDENTIFIER_PREFIX = 'GUEST#';

export const decodeRouteParam = (value: string): string => {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
};

export const isProvisionalGuestCustomerId = (customerId?: string): boolean => {
  if (!customerId) {
    return false;
  }
  return decodeRouteParam(customerId).startsWith(GUEST_IDENTIFIER_PREFIX);
};

export const provisionalGuestPath = (guestIdentifier: string): string =>
  `${routes.customer}/${encodeURIComponent(guestIdentifier)}`;

/** Sidebar routes that are not available while viewing a provisional guest profile. */
export const isProvisionalGuestRestrictedBrandLink = (route: string): boolean =>
  route === routes.orders ||
  route === routes.supportHistory ||
  route === routes.giftCard ||
  route.startsWith('/offers') ||
  route === routes.ctgLoyalty ||
  route === routes.store ||
  route === routes.quests;
